package com.ragnorak.clanybackoffice.di

import com.clany.backoffice.data.repository.AccountRepositoryImpl
import com.clany.backoffice.data.repository.AuthRepositoryImpl
import com.clany.backoffice.data.repository.DashboardRepositoryImpl
import com.clany.backoffice.data.repository.MemberRepositoryImpl
import com.clany.backoffice.data.repository.SubscriptionRepositoryImpl
import com.clany.backoffice.data.repository.UserRepositoryImpl
import com.clany.backoffice.data.repository.KeycloakRepositoryImpl
import com.clany.backoffice.data.repository.InvitationRepositoryImpl
import com.clany.backoffice.data.repository.SubscriptionPlanRepositoryImpl
import com.clany.backoffice.data.repository.SubscriptionWebhookEventRepositoryImpl
import com.clany.backoffice.data.repository.SystemConfigRepositoryImpl
import com.clany.backoffice.domain.repository.AccountRepository
import com.clany.backoffice.domain.repository.AuthRepository
import com.clany.backoffice.domain.repository.DashboardRepository
import com.clany.backoffice.domain.repository.MemberRepository
import com.clany.backoffice.domain.repository.SubscriptionRepository
import com.clany.backoffice.domain.repository.UserRepository
import com.clany.backoffice.domain.repository.KeycloakRepository
import com.clany.backoffice.domain.repository.InvitationRepository
import com.clany.backoffice.domain.repository.SubscriptionPlanRepository
import com.clany.backoffice.domain.repository.SubscriptionWebhookEventRepository
import com.clany.backoffice.domain.repository.SystemConfigRepository
import com.clany.backoffice.di.AppScope
import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provides

@ContributesTo(AppScope::class)
interface RepositoryModule {
    @Provides
    fun provideUserRepository(impl: UserRepositoryImpl): UserRepository = impl

    @Provides
    fun provideAccountRepository(impl: AccountRepositoryImpl): AccountRepository = impl

    @Provides
    fun provideAuthRepository(impl: AuthRepositoryImpl): AuthRepository = impl

    @Provides
    fun provideDashboardRepository(impl: DashboardRepositoryImpl): DashboardRepository = impl

    @Provides
    fun provideKeycloakRepository(impl: KeycloakRepositoryImpl): KeycloakRepository = impl

    @Provides
    fun provideMemberRepository(impl: MemberRepositoryImpl): MemberRepository = impl

    @Provides
    fun provideSubscriptionRepository(impl: SubscriptionRepositoryImpl): SubscriptionRepository = impl

    @Provides
    fun provideInvitationRepository(impl: InvitationRepositoryImpl): InvitationRepository = impl

    @Provides
    fun provideSubscriptionPlanRepository(impl: SubscriptionPlanRepositoryImpl): SubscriptionPlanRepository = impl

    @Provides
    fun provideSubscriptionWebhookEventRepository(impl: SubscriptionWebhookEventRepositoryImpl): SubscriptionWebhookEventRepository = impl

    @Provides
    fun provideSystemConfigRepository(impl: SystemConfigRepositoryImpl): SystemConfigRepository = impl
}
